import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import en from './locales/en.json';
import it from './locales/it.json';

// Get saved language from localStorage or default to 'it'
const savedLanguage = localStorage.getItem('appLanguage') || 'it';

// Initialize i18next
i18n
  .use(initReactI18next) // Connect i18next with React
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    lng: savedLanguage, // Use saved language or default
    fallbackLng: 'it', // fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// Persist language change to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('appLanguage', lng);
});

export default i18n;
